module.exports = __webpack_public_path__ + "img/20191105164401360截图20191105155346185.9a4a809e.jpg";